


















import Vue from "vue";
import mixins from "vue-typed-mixins";
import ItemExpander, { ItemExpanderMethods } from "../mixins/ItemExpander";
import { IPage, IConfig } from "../store/state";
import IsSmall from "../mixins/IsSmall";

interface PageExpanderMethods extends ItemExpanderMethods {}
interface PageExpanderComputed {
  config: IConfig,
  expanderRole: "tab" | "button";
  setAriaExpanded: string | null;
  setAriaSelected: string | null;
  isAccordionVisual: boolean;
}

export default mixins(ItemExpander, IsSmall).extend<
  {},
  PageExpanderMethods,
  PageExpanderComputed,
  {}
>({
  name: "PageExpander",
  methods: {
    setFocus() {
      (this.$refs.expander as HTMLElement).focus();
    }
  },
  computed: {
    config() {
      return this.$store.state.config;
    },
    isAccordionVisual() {
      return !this.$store.state.config.minimenu || this.isSmall;
    },
    expanderRole() {
      if (this.isAccordionVisual) {
        return "button";
      } else {
        return "tab";
      }
    },
    setAriaExpanded() {
      if (this.isAccordionVisual) {
        return this.ariaExpanded;
      }
      return null;
    },
    setAriaSelected() {
      if (!this.isAccordionVisual) {
        return this.ariaExpanded;
      }
      return null;
    }
  }
});
